import * as types from './types'

export function toggleMenuAction (status = null) {
    let action = {
        type: types.TOGGLE_MENU,
    }
    if (status !== null) {
        action.status = status;
    }

    return action;
}


export function initSiteOptions() {
    return dispatch => {
        return fetch(process.env.REACT_APP_APIHOST + '/wp-json/kwoot/siteoptions')
            .then(response => response.json())
            .then(json => dispatch(receiveSiteOptions(json)));
    }
}

function receiveSiteOptions(json) {
    return {
        type: types.FETCH_SITEOPTIONS_SUCCESS,
        site: {
            options: json
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/siteActions.js